import { type ReactNode } from 'react';
import styles from './InstallStep.module.css';

export const installStepBoldClassName = styles.bold;

interface InstallStepProps {
  icon: ReactNode;
  children: ReactNode;
}

export function InstallStep(props: InstallStepProps) {
  const { icon, children } = props;

  return (
    <div className={styles.root}>
      <div className={styles.icon}>{icon}</div>
      <p className={styles.text}>{children}</p>
    </div>
  );
}
